import React from 'react';
import { TabsListProps } from '../..';
import styles from '../../index.less';

interface TabsProps {
  tabs?: TabsListProps[];
  current: string;
  onChange?: (v: string) => void;
}

/** Tabs */
const Tabs: React.FC<TabsProps> = (props) => {
  return (
    <div className={styles['login-tabs']}>
      {props.tabs?.map((el, index) => (
        <span
          className={`${styles['tabs-item']} ${
            props.current === el.code ? styles['tabs-active'] : ''
          }`}
          key={el.code}
          onClick={() => props.onChange && props.onChange(el.code)}
        >
          {el.label}
        </span>
      ))}
    </div>
  );
};

export default Tabs;
